import { z } from "zod";

// ciscou-unauth-api proxies content-catalog-service's /certifications/exam-number unmodified
// (it's just a bottleneck for applying unauth rules/tokens) - reuse catalogService's schema
// instead of redeclaring it.
import ExamWithCertification from "@/services/catalogService/ExamWithCertification";
import unauthenticatedHttp from "@/services/unauthenticatedHttp";
import { catalogItemsResponse, courseDetailResponse } from "@/services/unauthService/types";

export async function fetch(id: string, includeParent?: boolean) {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/courses/${id}${includeParent ? "?includeParent=true" : ""}`
  );
  return courseDetailResponse.parse(data);
}

export async function getExam(
  examIds: Array<string>,
  includeCertifications?: boolean,
  includeTopics?: boolean
) {
  const { data } = await unauthenticatedHttp().post(
    `${globalThis.env.API_UNAUTH}/certifications/exam-number`,
    {
      exam_number: examIds,
      include_certifications: includeCertifications,
      include_topics: includeTopics,
      include_prescribed_prep_material: true,
    }
  );
  return ExamWithCertification.parse(data.Data);
}

export async function retrieveUnauthCatalogItems(body: object) {
  const { data } = await unauthenticatedHttp().post(
    `${globalThis.env.API_UNAUTH}/retrieveCatalogItems`,
    retrieveCatalogItemsBody.parse(body)
  );
  return catalogItemsResponse.parse(data).Data ?? [];
}

const retrieveCatalogItemsBody = z.object({
  guids: z.array(z.string()),
  recommended_podcast: z.boolean().optional(),
  type: z.string().optional(),
});
